   
<mat-drawer-container autosize>
    <mat-drawer class="pt-5" #drawer mode="side" opened>
        <div class="mat-title pt-3">
            <strong class="pl-4">Entity</strong>
        </div>
        <div class="p-3" *ngIf="entities.length > 0">
            <!-- *ngIf="processes.length > 0"> -->
            <div *ngFor="let entry of entities;let i = index">
                <div class="py-2 m-2 sectionHover" class="row col-12 px-0 py-2 px-2" style="font-weight:500;cursor: pointer;display:flex;"
                    (click)="onClickOfProcess(i)" [ngClass]="{'selected-style': entry.isSelected }">
                    <mat-icon class="col-1 mt-1 bulletIcon">lens</mat-icon><div class="col-10 pr-0 mat-subheading-2 pt-1">
                        {{entry.entityName}}</div>
                </div>
            </div>
        </div>
        <div class="p-4" *ngIf="entities.length == 0">
            <span class="p-3 mat-body-1">No Entities Available</span>
        </div>
    </mat-drawer>

    <mat-drawer-content class="drawer-content-bodyScroll pt-4" style="width:80%;">
        <div class="sidenav-content">
            <div class=" mat-drawer-content-container">
                <div class="col-6 row">
                    <mat-icon class="pr-3 logo-icon">security</mat-icon>
                    <strong class="mat-drawer-content-title mat-title pl-3">Advanced Security</strong>
                </div>
                <div class="col-md-3 col-sm-1 org-dropdown" *ngIf="loggedInUserTypeId == '1' ||loggedInUserTypeId == '5'">
                    <mat-select class="mat-body-1 p-2" (selectionChange)="orgChange($event)" [(value)]="defaultOrgId">
                        <mat-option class="mat-body-1" *ngFor="let org of orgValues" [value]="org.organizationId">
                            {{org.organizationName}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <form [formGroup]="searchForm" *ngIf="this.entities.length > 0" class="pad100">
                <mat-accordion class="row mt-3 mx-5 panelBorder" multi>
                    <mat-expansion-panel (opened)="filterOpen($event)" class="w-100 remShad" [expanded]="panelOpenState">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p class="m-4 lightBlue mat-subheading-1">Apply search filters</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>


                            <div class="row ml-1" style="display:flex !important;flex-wrap: wrap !important;">
                                <div class="row col-5 mx-2 pl-0 filter-fields"
                                    *ngFor="let field of searchableFields; let i=index">

                                    <div class="col-4 px-1 mr-2 align-items-center"> {{field.entityFieldName}}
                                    </div>
                                    <div class="col-6 px-1">
                                        <ng-container *ngIf="field.questionMasters.inputType == 'dte'">
                                            <input class="blue-border ht-30 w-100" id="{{field.questionMasters.questionId}}"
                                                type="date" />
                                        </ng-container>
                                        <ng-container *ngIf="field.questionMasters.inputType != 'dte'">
                                            <input id="{{field.questionMasters.questionId}}" class="blue-border ht-30 w-100">
                                        </ng-container>
                                    </div>

                                </div>
                                <div *ngIf="searchableFields.length == 0" class="mx-2">
                                    <div class="d-flex justify-content-center mat-subheading-1">No Advanced Filters set
                                    </div>
                                </div>
                            </div>
                        </div>
                        <mat-action-row class="pr-4">
                            <button mat-raised-button class="apply-button" [disabled]="searchableFields.length == 0"
                                (click)="applyFilters($event)">Search</button>
                            <button mat-raised-button [disabled]="searchableFields.length == 0" class="blue-border">Reset</button>
                        </mat-action-row>
                    </mat-expansion-panel>
                </mat-accordion>
            </form>
            <div class="pad150 " *ngIf="this.entities.length == 0">
               <span class="p-3 mat-body-1">No Lookup entities</span> 
            </div>

            <div #TABLE *ngIf="dataSource">
                <div *ngIf="dataSource.data.length" class="row mt-3 mx-5 overflow borderRadBtm">
                    <table mat-table #table aria-describedby=""
                        [dataSource]="dataSource.data | paginate: {itemsPerPage: size, currentPage: pageIndex, totalItems: totalItems}"
                        class="tblscroll" multiTemplateDataRows matSort>
                        <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index"
                            matColumnDef="{{disCol}}">
                            <div *ngIf="disCol != 'SupervisorId' && disCol != 'Action'">
                                <th mat-header-cell class="lightBlue" *matHeaderCellDef mat-sort-header><strong>{{disCol}}</strong></th>
                                <td mat-cell *matCellDef="let element ">
                                    {{element.value[disCol]}}
                                </td>
                            </div>

                            <div *ngIf="disCol == 'SupervisorId'">
                                <th mat-header-cell class="lightBlue" *matHeaderCellDef><strong>Supervisor</strong></th>
                                <td mat-cell *matCellDef="let element ">
                                    <mat-form-field appearance="outline" [ngClass]="{'disabled':editingrow==false ||(selectedEntityInstance!=null && selectedEntityInstance!=element.label)}">
                                        <mat-select placeholder="Select Supervisor" [value]="element.value.SupervisorId"  
                                            (selectionChange)="onSupChange($event,element)">
                                            <mat-option *ngFor="let sup of supervisorList" [value]="sup.customerId" >
                                                {{sup.firstName + ' ' +sup.lastName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </div>
                            <div *ngIf="disCol == 'Action'">
                                <th mat-header-cell *matHeaderCellDef class="table-heading action">
                                    <p class="mat-body-2">Actions</p>
                                </th>
                                <td mat-cell *matCellDef="let element let i=index" class=" action">
                                    <mat-icon class="mr-2 icon-grid" title="Edit" (click)="onRowEditInit(element)"
                                        *ngIf="editingrow==false ||(selectedEntityInstance!=null && selectedEntityInstance!=element.label)">
                                        <img class="iconzoom" src="/assets/icons/edit1.svg" alt="Edit icon" />
                                    </mat-icon>
                                    <mat-icon *ngIf="editingrow && selectedEntityInstance==element.label" class="mr-2 fa fa-floppy-o gridIcon"
                                        title="Save" aria-hidden="true" (click)="mapSupervisor(element)"></mat-icon>
                                    <mat-icon *ngIf="editingrow && selectedEntityInstance==element.label"
                                        style="color: red!important;padding-right: 0px;padding-left: 5px;" class="mr-2 fa fa-times gridIcon"
                                        title="Cancel  Edit" aria-hidden="true" (click)="onRowEditCancel(element)"></mat-icon>
                                
                                </td>
                            </div>
                        </ng-container>
                        <ng-container matColumnDef="header-row-first-group">
                            <th mat-header-cell *matHeaderCellDef [attr.colspan]=displayedColumns.length class="borderRad">
                                <div class="mat-subheading-1 text-left pt-3 heading-color">
                                    <p class="header-mat-panel-title mat-subheading-1 ">List of
                                        {{this.selectedEntity.entityName}}</p>
                                </div>
                            </th>
                        </ng-container>
                        <ng-container matColumnDef="header-row-size-group">
                            <th mat-header-cell class="pageItems" *matHeaderCellDef [attr.colspan]=displayedColumns.length>
                                <div class="mat-caption">
                                    Items per page:
                                    <mat-select [(value)]="size" (valueChange)="paginate(pageIndex)"
                                        style="width: 50px;margin-left: 15px">
                                        <mat-option [value]="5">5</mat-option>
                                        <mat-option [value]="10">10</mat-option>
                                        <mat-option [value]="20">20</mat-option>
                                    </mat-select>
                                </div>
                            </th>
                        </ng-container>
                        <tr mat-header-row class="tableHeading"
                            *matHeaderRowDef="['header-row-first-group']; sticky: true"></tr>
                        <tr mat-header-row class="pageItems" *matHeaderRowDef="['header-row-size-group']; sticky: true"></tr>
                        <tr mat-header-row class="pageItems" *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row class="pageItems" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div class="pagination1 w-100 borderRadBtm">
                        <pagination-controls (pageChange)="paginate($event)"></pagination-controls>
                    </div>
                </div>
                <!-- <div *ngIf="!dataSource.data.length && this.entities.length > 0">
                    No records found
                </div> -->
            </div>

            <!-- 
            <button mat-raised-button  class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();">
                <fa-icon *ngIf="!arrowIconToggle" [icon]="faAngleLeft" style="font-size:15px;color:#0f6bc1"></fa-icon>
                <fa-icon *ngIf="arrowIconToggle" [icon]="faAngleRight" style="font-size:15px;color:#0f6bc1"></fa-icon>
            </button> -->
        
        </div>



    </mat-drawer-content>
</mat-drawer-container>
